import { useEffect } from "react";
import {
  IonPage,
  IonContent,
  IonSpinner,
  useIonToast,
} from "@ionic/react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router";
import { openCommentsSheet } from "../../redux/reducer/commentsSheetSlice";
import { getPost } from "../../redux/actions";
import { buildCommunityPostFocusLocation } from "../../utils/communityDeepLinks";

// Shared-post links focus the post in the Community feed. Explicit comment
// links additionally open the comments sheet over that focused feed.
const useNavigateFromDeepLink = ({
  groupId,
  postId,
  commentId,
  openComments = false,
}) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [presentToast] = useIonToast();

  useEffect(() => {
    let cancelled = false;
    const isRealPost = /^\d+$/.test(String(postId || ""));
    if (!isRealPost) {
      history.replace("/community");
      return undefined;
    }

    dispatch(getPost({ postId, page: 1 }))
      .unwrap()
      .then((payload) => {
        if (cancelled) return;
        const resolvedPost = payload?.post_group;
        if (!resolvedPost?.id) throw new Error("post unavailable");
        // Keep the focus target in the URL so it survives Ionic route remounts.
        // Anchor mode also asks the feed API to return posts around this post.
        history.replace(buildCommunityPostFocusLocation(postId));
        if (openComments) {
          dispatch(
            openCommentsSheet({
              postGroup: resolvedPost,
              from_main_group: true,
              focusCommentId: commentId || null,
            }),
          );
        }
      })
      .catch(() => {
        if (cancelled) return;
        history.replace("/community");
        presentToast({
          message: "Questo post non è più disponibile.",
          duration: 2500,
          position: "top",
        });
      });

    return () => {
      cancelled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [groupId, postId, commentId, openComments, presentToast]);

  return null;
};

const Redirecting = () => (
  <IonPage>
    <IonContent className="ion-padding ion-text-center">
      <div style={{ marginTop: "40vh" }}>
        <IonSpinner name="crescent" />
      </div>
    </IonContent>
  </IonPage>
);

export const PostCommentsDeepLink = ({ match }) => {
  const { groupId, postId } = match.params;
  useNavigateFromDeepLink({ groupId, postId });
  return <Redirecting />;
};

export const CommentThreadDeepLink = ({ match }) => {
  const { groupId, postId, commentId } = match.params;
  useNavigateFromDeepLink({
    groupId,
    postId,
    commentId,
    openComments: true,
  });
  return <Redirecting />;
};
